/** @jsxImportSource @emotion/react */
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import React, { useState } from 'react';
import { ScheduleForm, ScheduleFormType } from '../../components';

interface OfferGeoScheduleProps {
  offerGeoId: string;
  isBlocked: boolean;
  isOpened: boolean;
  onClose: () => void;
  onHasSchedule?: (has: boolean) => void;
}

export function OfferGeoScheduleDialog({
  offerGeoId,
  isBlocked,
  isOpened,
  onClose,
  onHasSchedule,
}: OfferGeoScheduleProps): React.ReactElement {
  const [opened, setOpened] = useState(false);

  return (
    <Dialog
      data-test-id="add-offer-geo-dialog"
      fullWidth={true}
      maxWidth="sm"
      open={isOpened}
      scroll="paper"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      TransitionProps={{
        onEnter: () => setOpened(true),
        onExited: () => setOpened(false),
      }}
    >
      {(isOpened || opened) && (
        <ScheduleForm
          parentId={offerGeoId}
          isBlocked={isBlocked}
          type={ScheduleFormType.Geo}
          onHasSchedule={onHasSchedule}
        >
          <Button
            onClick={onClose}
            color="primary"
            type="button"
            data-test-id="add-offer-geo-dialog-cancel-button"
          >
            Cancel
          </Button>
        </ScheduleForm>
      )}
    </Dialog>
  );
}
